//@flow
import React from 'react';
import Link from '../../../components/Link';
import Sidebar from './Sidebar.react';
import CategoriesListItem from '../../Categories/components/CategoriesListItem.react';
import MobileMenuListItem from './MobileMenuListItem.react';
import CustomerModel from '../../Stores/Customer/customerModel';
import SessionActions from '../../Actions/session';
import ZopimLoader from '../../Chat/components/ZopimLoader.react';
import ModalActions from '../../Actions/modal';
import Constants from '../../constants';
import {SubPageLinks} from '../../Header/config/subPages';
import { withRouter } from 'react-router';

import type CategoryModel from '../../Stores/MemberCategories/categoryModel';
import type {ContextRouter} from 'react-router';
import { getIsCategoryHighlighted } from '../../Stores/MemberCategories/categoriesCollection';

type Props = ContextRouter&{
  open:boolean,
  loggedIn:boolean,
  customer:CustomerModel,
  onSetOpen:() => void,
  handleLoginClick:() => void,
  children?:React$Node,
  categories:CategoryModel[],
  showCategories?:boolean,
  hasSub?:boolean,
};

type State = {
  categoriesExpanded:boolean,
  accountExpanded:boolean,
  subPagesExpanded:boolean,
};

class MobileMenu extends React.Component<Props, State> {
  state = {
    categoriesExpanded: false,
    accountExpanded: true,
    subPagesExpanded: false,
  };

  handleLogoutClick = () => {
    this.toggleOpen();
    SessionActions.logout();
  }

  handleLoginClick = () => {
    this.toggleOpen();
    this.props.handleLoginClick();
  }

  openSearch = () => {
    this.toggleOpen();
    ModalActions.openModal(Constants.SEARCH_MODAL);
  }

  toggleOpen = () => {
    this.props.onSetOpen();
  }

  getIsOfficeRoute() {
    const {location} = this.props;
    return location.pathname.startsWith('/office');
  }

  toggleCategoriesExpanded = () => {
    this.setState({ categoriesExpanded: !this.state.categoriesExpanded });
  };

  toggleSubPagesExpanded = () => {
    this.setState({ subPagesExpanded: !this.state.subPagesExpanded });
  };

  toggleAccountExpanded = () => {
    this.setState({ accountExpanded: !this.state.accountExpanded });
  };

  renderCategoryItems() {
    if (this.state.categoriesExpanded) {
      return (
        <ul className="category-items">
          {this.props.categories.map(c => (
            <CategoriesListItem
              key={c.getId()}
              item={c}
              onClick={this.toggleOpen}
              highlighted={getIsCategoryHighlighted(c.getUrlKey())}
            />
          ))}
        </ul>
      );
    }
  }

  renderSubPageItems() {
    if (this.state.subPagesExpanded) {
      return (
        <ul className="category-items">
          {SubPageLinks.map((item, index) => (
            <MobileMenuListItem
              key={index}
              label={item.label}
              link={item.link}
            />
          ))}
        </ul>
      );
    }
  }

  getCategoriesOption() {
    const cls = this.state.categoriesExpanded
      ? 'option-button expanded'
      : 'option-button';
    return (
      <>
        <button
          onClick={this.toggleCategoriesExpanded}
          className={cls}
        >
          <span>Shop categories</span>
          <div className="option-button-icon"></div>
        </button>
        {this.renderCategoryItems()}
      </>
    );
  }

  getSubPagesOption() {
    const cls = this.state.subPagesExpanded
      ? 'option-button expanded'
      : 'option-button';
    return (
      <>
        <button
          onClick={this.toggleSubPagesExpanded}
          className={cls}
        >
          <span>Use Cases</span>
          <div className="option-button-icon"></div>
        </button>
        {this.renderSubPageItems()}
      </>
    );
  }

  getTabs() {
    const isOffice = this.getIsOfficeRoute();
    const tabs = [
      {
        to: '/',
        external: false,
        label: 'Home',
        className: `sidebar-tab ${!isOffice ? 'active' : ''}`,
      },
      {
        to: '/office',
        external: true,
        label: 'Business',
        className: `sidebar-tab ${isOffice ? 'active' : ''}`,
      },
    ];
    return (
      <div className="sidebar-tabs">
        {tabs.map((tab, index) => (
          <Link
            to={tab.to}
            external={tab.external}
            className={tab.className}
            key={index}
            onClick={this.toggleOpen}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    );
  }

  renderAccountItems() {
    const {hasSub} = this.props;
    if (this.state.accountExpanded) {
      return (
        <ul className="account-items">
          <li>
            <Link to="/account">Account settings</Link>
          </li>
          {hasSub &&
            <li>
              <Link to="/account/subscription">Subscriptions</Link>
            </li>
          }
          <li>
            <Link to="/orders">Order history</Link>
          </li>
          <li>
            <Link to="/my-products" external={true}>
              My products
            </Link>
          </li>
          <li>
            <Link to="/snackpass-admin" className="mobile-menu-link" external={true}>
              <div className="mobile-menu-link-label">SnackPass</div>
              <div className="mobile-menu-link-new">NEW</div>
            </Link>
          </li>
          <li>
            <button
              onClick={this.handleLogoutClick}
            >
              Log out
            </button>
          </li>
        </ul>
      );
    }
  }

  getAccountOptions() {
    const {loggedIn, customer} = this.props;
    if (loggedIn) {
      const displayName = (customer && customer.getFirstname()) || 'Account';
      const cls = this.state.accountExpanded
        ? 'option-button expanded'
        : 'option-button';
      return (
        <>
          <button
            onClick={this.toggleAccountExpanded}
            className={cls}
          >
            <span>{displayName}</span>
            <div className="option-button-icon"></div>
          </button>

          {this.renderAccountItems()}
        </>
      );
    } else {
      return (
        <button
          className="sign-in-button"
          onClick={this.handleLoginClick}
        >
          Sign in
        </button>
      );
    }
  }

  getOfficeItems() {
    return (
      <>
        <li>
          {this.getAccountOptions()}
        </li>
        <li>
          <Link to="/office/catalog" external={true}>Snack catalog</Link>
        </li>
        <li>
          <Link to="/office/pricing" external={true}>Pricing</Link>
        </li>
        <li>
          <Link to="/office/pantry" external={true}>In-office</Link>
        </li>
        <li>
          <Link to="/office/remote" external={true}>Remote</Link>
        </li>
        <li>
          {this.getSubPagesOption()}
        </li>
        <li>
          <Link to="/office/refer">Refer an office</Link>
        </li>
        <li>
          <Link to="/office/podcast" external={true}>Podcast</Link>
        </li>
        <li>
          <Link to="https://naturebox.com/blog" external={true}>Blog</Link>
        </li>
        <li>
          <Link to="/office?start=true" external={true}>Get started</Link>
        </li>
      </>
    );
  }

  getDtcItems() {
    const {showCategories} = this.props;
    return (
      <>
        <li>
          {this.getAccountOptions()}
        </li>
        <li>
          <button
            className="sidebar-button"
            onClick={this.openSearch}
          >
            Search
          </button>
        </li>
        {showCategories &&
          <li>
            {this.getCategoriesOption()}
          </li>
        }
        <li>
          <Link to="/aboutus" external={true}>
            About us
          </Link>
        </li>
        <li>
          <a href={Constants.SUPPORT_LINK} onClick={this.toggleOpen}>
            FAQs
          </a>
        </li>
        <li>
          <ZopimLoader onlineTextMobile="Help" />
        </li>
      </>
    );
  }

  getSidebarContent() {
    const items = this.getIsOfficeRoute()
      ? this.getOfficeItems()
      : this.getDtcItems();
    return (
      <div className="sidebar scrollable">
        {this.getTabs()}
        <ul className="sidebar-items">
          {items}
        </ul>
      </div>
    );
  }

  render() {
    return (
      <Sidebar
        sidebar={this.getSidebarContent()}
        open={this.props.open}
        onSetOpen={this.props.onSetOpen}
      >
        {this.props.children}
      </Sidebar>
    );
  }
}

export default withRouter(MobileMenu);
